var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MyFooter-container"},[_c('p',[_vm._v("网站备案号：鲁ICP备11019782号")]),_c('p',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.open}},[_vm._v("工信部备案网站查询链接：https://beian.miit.gov.cn/")])])
}
var staticRenderFns = []

export { render, staticRenderFns }